var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article)?_c('section',[_c('Title',{attrs:{"title":_vm.article.title}}),_c('section',{staticClass:"info"},[_c('Description',{attrs:{"content":_vm.article.content,"illustration":_vm.article.illustration}}),_c('Author')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }